import MainLayout from '@/common/components/layouts/MainLayout';
import SignatureContainer from '@/modules/adjusterReportModules/components/signatureContainer/SignatureContainer';

export default ({ editable }: { editable: boolean }) => {
  return (
    <MainLayout
      title="بیمه گذار / تصاویر"
      header="titleHeader"
      hasBottomPadding
    >
      <SignatureContainer type="Body" editable={editable} />
    </MainLayout>
  );
};
